import React from 'react';
import react from '../images/react.svg';
import { motion } from 'framer-motion';
import { skill_language_store, skill_tool_store } from './skillStore';

const SkillWrapper = ({ name, level, icon }) => {
	let className = 'skill'

	if (level === 'beginner')
		className = `${className} ${className}_beg`
	if (level === 'average')
		className = `${className} ${className}_avg`
	else if (level === 'very good')
		className = `${className} ${className}_verygood`
	else if (level === 'experience')
		className = `${className} ${className}_exp`
	if (!icon) {
		icon = react
	}
	return (
		<div className="skill_wrapper">
			<div className={className}>
				<span className="skill_name"><img src={icon} alt={name} className='icon_tiny mr-2' />{name}</span>
				<span className='skill_level'></span>
			</div>
		</div>
	)
};
const Resume = () => {
	const resumeVariants = {
		initial: {
			opacity: 0
		},
		visible: {
			opacity: 1,
			transition: {
				delay: 0.1,
				duration: 0.7
			}
		},
		exit: {
			opacity: 0,
			transition: {
				ease: 'easeInOut'
			}
		}
	};
	return (
		<motion.div className="container resume_section"
			variants={resumeVariants}
			initial='initial'
			animate='visible'
			exit='exit'
		>
			<div className="row">
				<div className="col-12 col-lg-6 resume_card">
					<div className="sub_heading">{'Education'}</div>
					<div className="resume_card_body">
						<div className='resume_card_title'>
							<h5>{'Electronics and Communication Engineering'}</h5>
						</div>
						<div className='resume_card_year'>{'Electronics and Communication (2011-2015)'}</div>
						<p className='resume_card_description'>
							{'Persued B.tech in Electronics and Communication Engineering from Electronics and Communication Engineering'}
							<br />{'CGPA : 7.43'}
						</p>
					</div>
				</div>
				<div className="col-12 col-lg-6 resume_card">
					<div className="sub_heading">{'Experience'}</div>
					<div className="resume_card_body">
						<div className='resume_card_title'><h5>{'Capgemini'}</h5></div>
						<div className='resume_card_year'>{'sep 2016 - oct-2021'}</div>
						<p className='resume_card_description'>
							{'Worked with Capgemini India as Frontend Developer and AEM UI. I focus primarily on building and implementing user interfaces that are usable and scalable.'}
						</p>
						<div className='resume_card_title'><h5>{'TCS'}</h5></div>
						<div className='resume_card_year'>{'oct-2021 -tilldate'}</div>
						<p>{'Currently working with the TCS as React Js Developer.'}</p>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12 col-lg-6 skill_div">
					<div className="sub_heading">{'Language & Framework'}</div>
					<div className="resume_card_body">
						{skill_language_store.map((skill, i) => <SkillWrapper key={i} name={skill.name} level={skill.level} icon={skill.logo} />)}
					</div>
				</div>
				<div className="col-12 col-lg-6">
					<div className="sub_heading">{'Tools & Software'}</div>
					<div className="resume_card_body">
						{skill_tool_store.map((skill, i) => <SkillWrapper key={i} name={skill.name} level={skill.level} icon={skill.logo} />)}
					</div>
				</div>
			</div>
		</motion.div>

	);
};

export default Resume;